export default "__VITE_ASSET__9f70dceb__"